const SET_TAB = 'SET_TAB';
const LAST_SEEN = 'LAST_SEEN';
const SAVED = 'SAVED';
const APPLIED = 'APPLIED';

const setTab = ({ activeTab }) => ({
  type: SET_TAB,
  activeTab
});

export {
  SET_TAB, LAST_SEEN, SAVED, APPLIED, setTab
};
